import { Link } from "react-router-dom";
import classes from "./OgxHero.module.css";
import heroImage from "../../Assets/Images/ogx-hero.png";

const OgxHero = () => {
  return (
    <section className={classes.hero}>
      <span className={classes.scrollDown}>
        SCROLL DOWN
        <span className={classes.scrollLine} />
      </span>

      <div className={classes.heroInner}>
        <h1 className={classes.title}>
          GO{" "}
          <span className={classes.highlight}>
            GLOBAL
            <svg
              className={classes.underline}
              xmlns="http://www.w3.org/2000/svg"
              width="125"
              height="9"
              viewBox="0 0 125 9"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M1 7.94615C29.5101 7.94615 57.8234 2.32561 86.4499 2.11512C98.3222 2.02783 110.086 1.95706 121.94 2.11512C125.151 2.15794 125.009 1.52784 121.796 1.46722C116.092 1.3596 110.85 0.378442 105.023 0.675354C94.2642 1.22357 83.4704 0.831205 72.7001 1.32324C50.7367 2.32664 28.7512 1.95116 6.83105 2.76301"
                stroke="#037EF3"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </span>{" "}
          WITH YOUR SKILLS
        </h1>

        <p className={classes.tagline}>
          Your degree gets you started. Global experience sets you apart.
        </p>
        <p className={classes.subtext}>
          Explore verified internships, teaching placements, and social impact
          projects abroad with AIESEC in Nigeria
        </p>

        <Link className={classes.cta} to="/ogx/apply">
          Get Started
        </Link>
      </div>

      <div className={classes.imageWrap}>
        <img
          className={classes.image}
          src={heroImage}
          alt="AIESEC in Nigeria exchange participants together outdoors"
          loading="lazy"
        />
        <svg
          className={classes.star}
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="73"
          viewBox="0 0 76 77"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M4.81493 16.3982C2.36976 12.2171 6.70344 7.34975 11.1392 9.29511L27.9895 16.685C29.9733 17.555 32.2916 17.0487 33.732 15.4309L45.9673 1.6889C49.1882 -1.92864 55.1565 0.688828 54.6771 5.50865L52.8559 23.8179C52.6415 25.9733 53.8394 28.0218 55.8232 28.8918L72.6735 36.2816C77.1092 38.227 76.4642 44.7121 71.7321 45.7455L53.7563 49.6713C51.64 50.1335 50.062 51.9058 49.8476 54.0613L48.0265 72.3705C47.547 77.1903 41.1801 78.5808 38.7349 74.3997L29.4464 58.5168C28.3529 56.647 26.1797 55.6939 24.0634 56.1561L6.08759 60.0819C1.35551 61.1153 -1.93445 55.4897 1.28643 51.8721L13.5217 38.1301C14.9621 36.5123 15.197 34.151 14.1035 32.2811L4.81493 16.3982Z"
            fill="#037EF3"
          />
        </svg>
      </div>
    </section>
  );
};

export default OgxHero;
